import {createEffect} from "effector";

export const sendHREventFx = createEffect().use(async (payload) => {
	try {
		const response = await fetch(
			'https://6lga65wdw5.execute-api.eu-west-1.amazonaws.com/HREvent1/UserRecords',

			{
				method: 'POST',
				body: JSON.stringify(payload)
			}
		)

		return await response.json()
	} catch (e) {
		console.error(e)
	}
})
